import React, { Fragment } from "react";

import { getText } from "../../helpers";

const LabeledText = (props) => {
  const { label, text, separator = ":" } = props;
  const className = props.className ? `labeled-text ${props.className}` : "labeled-text";
  return (
    <span className={className}>
      <span className="label">{label}</span>
      <span className="separator">{separator}</span>
      <span className="text">{text}</span>
    </span>
  );
};

export default function UnwantedEventDescription(props) {
  const { workPhase, activity, hazard, unwantedEvent, label } = props;
  const className = props.className ? `risk-description ${props.className}` : "risk-description";
  return (
    <div className={className}>
      { label && <label>{label}: </label> }
      <LabeledText label={getText("Work Phase or Ambient Exposure")} text={workPhase} />
      {
        activity &&
        <Fragment>
          <span className="risk-description-separator">|</span>
          <LabeledText label={getText("Activity")} text={activity} />
        </Fragment>
      }
      {
        hazard &&
        <Fragment>
          <span className="risk-description-separator">|</span>
        <LabeledText label={getText("Hazard (Risk Source)")} text={hazard} />
        </Fragment>
      }
      {
        unwantedEvent &&
        <Fragment>
          <span className="risk-description-separator">|</span>
          <LabeledText label={getText("(Unwanted) Event")} text={unwantedEvent} />
        </Fragment>
      }
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/controls_component/unwanted_event_description.js